import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  header: {
    id: 'pages.dashboard.header',
    defaultMessage: '<strong>.ART</strong> Referral Program',
  },
  allReferrals: {
    id: 'pages.dashboard.allReferrals',
    defaultMessage: 'All referrals',
  },
  allReferralsTooltip: {
    id: 'pages.dashboard.allReferralsTooltip',
    defaultMessage: 'The total number of referrals that have passed through the referral link',
  },
  earnedThisMonth: {
    id: 'pages.dashboard.earnedThisMonth',
    defaultMessage: 'Earned this month',
  },
  earnedThisMonthTooltip: {
    id: 'pages.dashboard.earnedThisMonthTooltip',
    defaultMessage: 'Total amount of rewards for the last 30 days',
  },
  earnedToDate: {
    id: 'pages.dashboard.earnedToDate',
    defaultMessage: 'Earned to date',
  },
  earnedToDateTooltip: {
    id: 'pages.dashboard.earnedToDateTooltip',
    defaultMessage: 'Total amount of all rewards for all time',
  },
  onHold: {
    id: 'pages.dashboard.onHold',
    defaultMessage: 'On hold',
  },
  onHoldTooltip: {
    id: 'pages.dashboard.onHoldTooltip',
    defaultMessage: 'Amount of approved rewards for the at this moment since last payment',
  },
  alreadyReceived: {
    id: 'pages.dashboard.alreadyReceived',
    defaultMessage: 'Already received',
  },
  alreadyReceivedTooltip: {
    id: 'pages.dashboard.alreadyReceivedTooltip',
    defaultMessage: 'Already paid reward (for all time)',
  },
  upcomingPayments: {
    id: 'pages.dashboard.upcomingPayments',
    defaultMessage: 'Upcoming payments',
  },
  upcomingPaymentsTooltip: {
    id: 'pages.dashboard.upcomingPaymentsTooltip',
    defaultMessage: 'Amount of the approved rewards to the next payment',
  },
  referralLink: {
    id: 'pages.dashboard.referralLink',
    defaultMessage: 'Your referral link',
  },
  referralLinkTooltip: {
    id: 'pages.dashboard.referralLinkTooltip',
    defaultMessage: "Use this link to invite your referrals.<br />Use our <a href='https://promo.art.art' target='_blank' rel='nofollow noopener'>advertising materials</a> to gain more registrations",
  },
  noData: {
    id: 'pages.dashboard.noData',
    defaultMessage: "We'll soon be updating your profile…",
  },
});



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/messages.js